import Inherit from '../../core/inherit';
import ShelfController from '../../core/shelf.controller';
import NotificationsDelegate from './notifications.delegate';

class NotificationsController extends Inherit(ShelfController, NotificationsDelegate) {
    async initialize() {
        if (this.isAuthenticated) {
            await this.fetchNotificationsData();
        } else {
            this.navigateLogin();
        }
    }

    async fetchNotificationsData(filters = {}) {
        try {
            this.setState({ loading: true });

            const [notificationsResponse, stats] = await Promise.all([
                this.data.fetchNotifications(filters),
                this.data.fetchNotificationStats()
            ]);

            const notifications = notificationsResponse?.data || [];

            this.setState({
                notifications,
                filteredNotifications: notifications,
                stats,
                loading: false
            });
        } catch (error) {
            console.error('Error fetching notifications:', error);
            this.setState({ loading: false });
        }
    }

    async refreshNotifications() {
        const { filterType, filterSeverity, filterRead } = this.state;
        const filters = {};

        if (filterType && filterType !== 'all') filters.type = filterType;
        if (filterSeverity && filterSeverity !== 'all') filters.severity = filterSeverity;
        if (filterRead !== 'all') filters.read = filterRead === 'unread' ? false : true;

        await this.fetchNotificationsData(filters);
    }

    async markAsRead(id) {
        try {
            await this.data.markNotificationAsRead(id, this.user._id);
            await this.refreshNotifications();
        } catch (error) {
            console.error('Error marking notification as read:', error);
        }
    }

    async markMultipleAsRead(ids) {
        try {
            await this.data.markMultipleNotificationsAsRead(ids, this.user._id);
            await this.refreshNotifications();
        } catch (error) {
            console.error('Error marking notifications as read:', error);
        }
    }

    async dismissNotification(id) {
        try {
            await this.data.dismissNotification(id, this.user._id);
            await this.refreshNotifications();
        } catch (error) {
            console.error('Error dismissing notification:', error);
        }
    }

    async deleteNotification(id) {
        try {
            await this.data.deleteNotification(id);
            await this.refreshNotifications();
        } catch (error) {
            console.error('Error deleting notification:', error);
        }
    }

    viewNotificationStoreCheck(storeCheckId) {
        this.props.navigate(`/dashboard/storecheck/storecheck?id=${storeCheckId}`);
    }

    viewNotificationClient(clientId) {
        this.props.navigate(`/dashboard/clients/client?id=${clientId}`);
    }

    viewNotificationStore(storeId) {
        this.props.navigate(`/dashboard/stores/store?id=${storeId}`);
    }

    setFilterType(type) {
        this.setState({ filterType: type }, () => this.refreshNotifications());
    }

    setFilterSeverity(severity) {
        this.setState({ filterSeverity: severity }, () => this.refreshNotifications());
    }

    setFilterRead(read) {
        this.setState({ filterRead: read }, () => this.refreshNotifications());
    }
}

export default NotificationsController;

